import React, { MouseEvent } from "react";
import ReactDOM from "react-dom";

import * as _ from "lodash";

import { UiUtils } from "./common/uiUtils";
import { ViewerUtils } from "./common/viewerUtils";

/**
 * The view that's shown if the user accesses a model that's still queued / processed at Autodesk services.
 */

const App = (props) => {
    const url = `${ViewerUtils.baseUrl()}/${props.queryId}`;
    return <div>
        The model is being processed. This page will reload.
           </div>;
}

interface PendingProps {
    id: string;
}

class Pending extends React.Component<PendingProps> {

    private interval;

    constructor(props) {
        super(props);
    }

    componentDidMount(): void {
        this.interval = setInterval(() => location.reload(), 10000);
    }

    componentWillUnmount(): void {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    render() {
        return <div className="centered-view">
                   The model is being processed. This page will reload once the model is ready.
               </div>;
    }
}

export function startPending(id: string) {
    ReactDOM.render(<Pending id={id}/>, document.getElementById("pending-status"));
}

